import React from 'react'

function TenderTextKKS() {
  return (
    <embed src="\pdfs\EAT2.1.1_KKS-3LD_Contact_cooling_ceiling_system_Krantz.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextKKS